import { BaseModel } from "@puntaje/shared/core"

export class Configuracion extends BaseModel {
    public configuracion: any
}
